/**
 * Copy to Clipboard functionality for share links
 */
export function initCopyToClipboard() {
  const copyButtons = document.querySelectorAll('.post-sharing__copy-btn');
  
  if (!copyButtons.length) {
    return;
  }

  console.log('Copy to clipboard initialized:', copyButtons.length, 'buttons found');

  /**
   * Show tooltip above the button
   */
  function showTooltip(button) {
    // Remove any existing tooltip from body
    const existingTooltip = document.body.querySelector('.post-sharing__tooltip');
    if (existingTooltip) {
      existingTooltip.remove();
    }

    // Create tooltip element
    const tooltip = document.createElement('div');
    tooltip.className = 'post-sharing__tooltip';
    tooltip.textContent = 'Link copied!';
    tooltip.setAttribute('role', 'status');
    tooltip.setAttribute('aria-live', 'polite');
    
    // Append to body for fixed positioning
    document.body.appendChild(tooltip);
    
    console.log('Tooltip created and appended to body');
    
    // Position tooltip - need to measure after it's in the DOM
    requestAnimationFrame(() => {
      const buttonRect = button.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      
      console.log('Button rect:', buttonRect);
      console.log('Tooltip rect:', tooltipRect);
      
      // Center horizontally relative to button
      const left = buttonRect.left + (buttonRect.width / 2) - (tooltipRect.width / 2);
      
      // Position above button with 8px gap (using viewport coordinates for fixed positioning)
      const top = buttonRect.top - tooltipRect.height - 8;
      
      // Ensure tooltip doesn't go off screen
      const minLeft = 8;
      const maxLeft = window.innerWidth - tooltipRect.width - 8;
      const adjustedLeft = Math.max(minLeft, Math.min(maxLeft, left));
      
      tooltip.style.left = `${adjustedLeft}px`;
      tooltip.style.top = `${top}px`;
      
      console.log('Tooltip positioned at:', { left: adjustedLeft, top });
      
      // Trigger animation after positioning
      requestAnimationFrame(() => {
        tooltip.classList.add('is-visible');
        console.log('Tooltip is-visible class added');
      });
    });
    
    // Remove tooltip after animation
    setTimeout(() => {
      tooltip.classList.remove('is-visible');
      setTimeout(() => {
        if (tooltip.parentElement) {
          tooltip.remove();
        }
      }, 300); // Match CSS transition duration
    }, 2000);
  }

  copyButtons.forEach((button) => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      
      let url = button.getAttribute('data-url');
      
      if (!url) {
        console.error('No URL found on copy button');
        return;
      }

      console.log('Raw URL from attribute:', url);

      // Decode HTML entities if any
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = url;
      url = tempDiv.textContent || tempDiv.innerText || url;

      // Clean the URL - remove any leading backslashes
      url = url.trim().replace(/^\\+/, '');
      
      // Prepend "https:" to the beginning if it doesn't already have a protocol
      if (!url.match(/^https?:\/\//i)) {
        url = 'https:' + url;
      }

      console.log('Cleaned URL:', url);

      try {
        // Try modern clipboard API first
        await navigator.clipboard.writeText(url);
        console.log('URL copied to clipboard successfully');
        
        // Show tooltip
        showTooltip(button);
        
        // Update aria-label for screen readers
        const originalAriaLabel = button.getAttribute('aria-label');
        button.setAttribute('aria-label', 'Link copied!');
        
        setTimeout(() => {
          button.setAttribute('aria-label', originalAriaLabel || 'Copy link');
        }, 2000);
      } catch (err) {
        // Fallback for older browsers or when clipboard API is not available
        const textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
          const successful = document.execCommand('copy');
          
          if (successful) {
            // Show tooltip
            showTooltip(button);
            
            // Update aria-label for screen readers
            const originalAriaLabel = button.getAttribute('aria-label');
            button.setAttribute('aria-label', 'Link copied!');
            
            setTimeout(() => {
              button.setAttribute('aria-label', originalAriaLabel || 'Copy link');
            }, 2000);
          } else {
            console.error('Failed to copy using execCommand');
          }
        } catch (err) {
          console.error('Failed to copy:', err);
        }
        
        document.body.removeChild(textArea);
      }
    });
  });
}
